import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import "./uploadImage.css";
import NavBar from "../../components/bar/navBar";
import ButtonComponent from "../../components/button";
import { app } from "../../components/firebase/firebase";
import imageCompression from "browser-image-compression";
import "firebase/compat/storage";
import Notification from "../../components/notification";
import AudioSource from "../../assets/sound/check.mp3";
import { formatDate, generateKeywords } from "../../components/function";

const MAX_IMAGE_SIZE = 250 * 1024; // 250 KB
const MAX_COMPRESSED_SIZE = 200 * 1024; // 200 KB

function UploadImage() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState("none");
  const [notification, setNotification] = useState(false);

  const db = app.firestore();

  useEffect(() => {
    setNotification(false);
  }, []);

  // Compression des images
  const compressImage = async (file) => {
    if (file.size <= MAX_IMAGE_SIZE) return file;

    try {
      const options = {
        maxSizeMB: MAX_COMPRESSED_SIZE / 1024 / 1024,
        maxWidthOrHeight: 400,
        useWebWorker: true,
      };
      return await imageCompression(file, options);
    } catch (error) {
      console.error("Erreur lors de la compression de l'image :", error);
      return null;
    }
  };

  // Gestion des fichiers déposés
  const onDrop = async (acceptedFiles) => {
    const compressedFiles = await Promise.all(
      acceptedFiles.map((file) => compressImage(file))
    );

    const validFiles = compressedFiles.filter(Boolean).map((file, index) => ({
      id: index,
      url: URL.createObjectURL(file),
      name: file.name,
      size: file.size,
      tags: ["montagne", "montagne", "montagne"], // Exemple de tags
    }));

    setImages(validFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  // Envoi des fichiers
  const handleSubmit = async () => {
    setLoading("loading");

    try {
      const storageRef = app.storage().ref();
      const uploadPromises = images.map(async (file) => {
        const date = Date.now();
        const response = await fetch(file.url);
        const blob = await response.blob();

        const imageRef = storageRef.child(
          `titoumr/images/${date} - ${file.name}`
        );
        await imageRef.put(blob);

        const downloadURL = await imageRef.getDownloadURL();
        await db
          .collection("titoumr")
          .doc("public")
          .collection("images")
          .add({
            date,
            name: file.name,
            path: `${date} - ${file.name}`,
            fullPath: imageRef.fullPath,
            size: file.size,
            link: downloadURL,
            dateCreated: formatDate(date),
            keywords: generateKeywords(file.name),
          });
      });

      await Promise.all(uploadPromises);

      // Nettoyage après succès
      images.forEach((image) => URL.revokeObjectURL(image.url));
      setImages([]);
      setNotification(true);
      const audio = new Audio(AudioSource);
      audio.play();
    } catch (error) {
      console.error("Erreur lors de l'envoi des fichiers :", error);
    } finally {
      setLoading("none");
    }
  };

  return (
    <>
      <NavBar link="/" title="Administration" />
      <Notification state={notification} />
      <div className="UploadImage">
        <div className="header">
          <h1>Ajouter des images</h1>
        </div>
        <div className="wrapper">
          <div className="square">
            <div {...getRootProps()} className="dropzone">
              <input {...getInputProps()} />
              <p>
                Faites glisser et déposez des images ici, ou cliquez pour
                sélectionner.
              </p>
            </div>
          </div>
          <div className="result">
            {images.map((data) => (
              <div className="container" key={data.id}>
                <div className="left">
                  <img src={data.url} alt="" />
                  <div className="ctn-text">
                    <div className="title">{data.name}</div>
                    <div className="size">
                      {(data.size / 1024).toFixed(1)} KB
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {images.length > 0 && (
              <div className="ctn-button">
                <ButtonComponent
                  text="Envoyer"
                  onClick={handleSubmit}
                  state={loading}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default UploadImage;
